module.exports = __webpack_public_path__ + "static/cover-99b56953fca1f98c4989b64ac2cc8d70.png";